import NarinLayout from "components/NarinLayout";
import GridIcon from "icons/GridIcon";
import ListIcon from "icons/ListIcon";

import { MenuProps, Pagination, PaginationProps, Spin } from "antd";
import { CustomPaginationItem } from "components/Desktop/CustomPaginationItem";
import ProductList from "components/Desktop/ProductList";
import RelatedProduct from "components/Desktop/RelatedProduct";
import SideFilter from "components/Desktop/SideFilter";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSearchProduct } from "services/product";
import useIsDesktopStore from "stores/isDesktop";
const items: MenuProps["items"] = [
  // {
  //   label: <a href="https://www.antgroup.com">1st menu item</a>,
  //   key: "0",
  // },
  // {
  //   label: <a href="https://www.aliyun.com">2nd menu item</a>,
  //   key: "1",
  // },
  // {
  //   type: "divider",
  // },
  // {
  //   label: "3rd menu item",
  //   key: "3",
  // },
];

const SearchPage = () => {
  const [isListView, setIsListView] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { productName } = useParams();
  const [filterCate, setFilterCate] = useState<string[]>();
  const { isDesktop } = useIsDesktopStore();

  const { productList, meta, isLoading } = useGetSearchProduct(
    encodeURIComponent(productName ?? ""),
    filterCate,
    currentPage
  );

  const onChangePage: PaginationProps["onChange"] = (page) => {
    setCurrentPage(page);
  };

  const onChangeFilter = (categoryId: string[]) => {
    setFilterCate(categoryId);
  };

  return (
    <NarinLayout>
      <div className="xl:flex xl:gap-2 xl:pt-8 p-4">
        <SideFilter onChange={onChangeFilter} />
        <div className="w-full ">
          {isDesktop && (
            <div className="flex justify-between items-center">
              <div>
                <span className="text-gray-400">ผลการค้นหา: </span>
                <span>{productName}</span>
              </div>
              <div className="flex gap-4">
                <div
                  className="cursor-pointer"
                  onClick={() => setIsListView(true)}
                >
                  <ListIcon style={{ opacity: isListView ? 1 : 0.5 }} />
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => setIsListView(false)}
                >
                  <GridIcon style={{ opacity: isListView ? 0.5 : 1 }} />
                </div>
              </div>
            </div>
          )}
          {!isDesktop && (
            <div className="mb-4">
              <span className="text-gray-400">ผลการค้นหา: </span>
              <span>{productName}</span>
            </div>
          )}
          {/* {isDesktop && (
            <div className="flex justify-between items-center mt-4">
              <div className="text-xl"></div>
              <div className="flex gap-2 text-sm items-center">
                <div>เรียงสินค้าตาม</div>
                <Dropdown menu={{ items }} trigger={["click"]}>
                  <Button type="primary" shape="round" className="text-sm">
                    <Space>
                      สินค้ามาใหม่
                      <ArrowDownIcon />
                    </Space>
                  </Button>
                </Dropdown>
              </div>
            </div>
          )} */}
          <div className="bg-white p-4 mt-4">
            <Spin tip="Loading" size="large" spinning={isLoading}>
              <div className="min-h-screen">
                <ProductList
                  isLoading={false}
                  isList={isListView}
                  data={productList}
                />
              </div>
            </Spin>
            <div className="mt-4 justify-center flex">
              <Pagination
                itemRender={CustomPaginationItem}
                current={currentPage}
                onChange={onChangePage}
                total={meta?.totalItems}
                showSizeChanger={false}
                pageSize={20}
                responsive
              />
            </div>
          </div>
        </div>
      </div>
      <div className="p-4">
        <RelatedProduct mainProductId={productList?.[0]?.id || NaN} />
      </div>
    </NarinLayout>
  );
};
export default SearchPage;
